import { ReactNode } from "react";
import { Typography, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../utils";
import OutcomeCard, { ReferenceBlock } from "./OutcomeCard";

const ErrorCard = ({
  totalAmount,
  errorMessage,
  reference,
  paymentReference,
  currency,
  actions,
}: {
  totalAmount: string;
  errorMessage?: string;
  reference?: string;
  paymentReference?: string;
  currency?: string;
  actions?: ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <OutcomeCard
      tone="error"
      title={t("stepper_4.failed_transaction")}
      // The amount lives in the price query, which has nothing when the link
      // carries no price inputs -- and an unguarded "0 FCFA" reads as a fact.
      total={
        Number(totalAmount) > 0
          ? formatCurrency(totalAmount, undefined, currency)
          : undefined
      }
      actions={actions}
    >
      {/* The payment item id is not a reference a payer or an agent can look
          a payment up by, so it is not shown. */}
      <Typography sx={{ fontSize: 15, color: "text.secondary", mb: 2 }}>
        {t("stepper_4.failed_message")}
      </Typography>
      {/* The reason is the one line a payer must not miss, so it is set
          apart from the grey text around it (MPAY-33410). */}
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 15,
          color: "error.dark",
          bgcolor: theme => alpha(theme.palette.error.main, 0.1),
          borderRadius: 1,
          px: 2,
          py: 1.5,
        }}
      >
        {/* No English default: an unresolved failure reaches the payer as
            the generic translated copy, in whichever locale they are on. */}
        {errorMessage || t("errors.unknown_error")}
      </Typography>
      {paymentReference && (
        <ReferenceBlock
          label={t("payment_reference.label")}
          value={paymentReference}
        />
      )}
      {reference && (
        <ReferenceBlock
          label={t("stepper_4.reference")}
          value={reference}
          copyLabel={t("copy.error_reference")}
          help={t("stepper_4.reference_help")}
        />
      )}
    </OutcomeCard>
  );
};

export default ErrorCard;
